import { atom } from 'recoil';

export const loginCollapseAtom = atom<boolean>({
  key: 'loginCollapseAtom',
  default: false,
});
